if (!customElements.get('recently-viewed')) {
  customElements.define('recently-viewed', class extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('[data-section-id]');
      this.howManyToShow = parseInt(this.dataset.limit) || 3;
      this.target = this.dataset.target;
      this.wrapperId = this.dataset.wrapperId || this.id;
    }

    connectedCallback() {
      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow,
        wrapperId: this.wrapperId,
        section: this.section,
        target: this.target,
        onComplete: (wrapper) => {
          this._filterExcluded(wrapper);
          this._applyCenteredClass(wrapper);
          this.dispatchEvent(new CustomEvent('theme:recently-viewed:loaded', { bubbles: false }));
        },
      });
    }

    _filterExcluded(wrapper) {
      const excludedHandle = this.dataset.excludedHandle;
      if (!excludedHandle || !wrapper) return;
      wrapper.querySelectorAll('[data-grid-item]').forEach((item) => {
        if ((item.dataset.url || '').split('?')[0] === `/products/${excludedHandle}`) {
          item.remove();
        }
      });
    }

    _applyCenteredClass(wrapper) {
      if (!wrapper) return;
      const remaining = wrapper.querySelectorAll('[data-grid-item]');
      if (remaining.length > 0 && remaining.length <= 2) {
        wrapper.classList.add('rs-grid--centered');
      }
    }
  });
}
